import React from "react";
import Navbar from "../Components/Navbar";
import AdminSignIn from "../Components/AdminSignIn";
import Footer from "../Components/Footer";
import '../Styles/AdminHome.scss';
import {Helmet} from "react-helmet";

function AdminHome() {
   return (
      <div>
         <Helmet>
            <title>Admin Sign In - Camp Connect</title>
         </Helmet>
         <AdminSignIn/>
      </div>
   )
};
export default AdminHome;
